<template lang="html">

  <section class="wrapper cv-area -programas">

    <div class="container">

      <h2 class="title-section">
        <span @click="toggleEdit">Programas informáticos</span>
        <button @click="showedit= true" class="cv-action-button edit"
          v-if="!showedit && !noedit"></button>
        <button @click="showedit= false" class="cv-action-button close" v-if="showedit">✕</button>
      </h2>

      <div class="contenedor-programas" v-if="!!owndata.programas">
        <h3 class="programa" :edit="showedit" v-for="(programa, key) in owndata.programas">
          <button class="erase" @click="erasePrograma(programa)"></button>
          {{programa.valor}}
        </h3>
      </div>

      <div class="otros-programas" v-if="!!owndata.otrosProgramas & !showedit">
        <h3 class="subtitle-section">Otros programas informáticos</h3>
        <p>{{owndata.otrosProgramas}}</p>
      </div>

      <p v-if="!showedit && !!!owndata.otrosProgramas && owndata.programas.length == 0 & !noedit">
        No tienes ningún programa, pulsa en <a @click="showedit= true">editar</a> para añadirlo</p>

      <p v-if="!showedit && !!!owndata.otrosProgramas && owndata.programas.length == 0 && noedit">Sin programas informáticos añadidos</p>


      <div class="editor-programas" v-if="showedit">

        <div class="contenedor-input row-start -with-btn">
          <label for="">Programas informáticos</label>
          <select v-model="selectprograma">
            <option value="">Selecciona un programa informático</option>
            <option v-if="!owndata.programas.some(p => p.clave == programa[0])" :value="programa" v-for="(programa,key) in dominios.programasInformaticos">{{programa[1]}}</option>
          </select>

          <button class="btn" @click="addPrograma">Añadir</button>

        </div>

        <div class="contenedor-input">
          <label for="">Otros programas informáticos</label>
          <textarea v-model="owndata.otrosProgramas"></textarea>
        </div>

        <button :loading="loading" class="btn" @click="save">Guardar</button>


      </div>

    </div>
  </section>

</template>

<script lang="js">

  import {mapActions, mapGetters} from 'vuex';

  export default {
    name: 'programas-informaticos',
    mounted(){
     this.setData();
    },
    props : ['cvdata','noedit'],
    data(){
      return{
        showedit : false,
        selectprograma : '',
        loading : false,
        owndata : {
          programas : [],
          otrosProgramas : '',
        }
      }
    },
    computed : {
      ...mapGetters({
        dominios : 'getDominiosOrder',
        isEstudiante : 'isEstudiante',
      }),
    },
    methods : {
      ...mapActions(['editProgramasInformaticos']),
      toggleEdit(){
        if(!this.noedit){
          this.showedit= !this.showedit
        }
      },
      addPrograma(){

        let select = {
          clave : Number(this.selectprograma[0]),
          valor : this.selectprograma[1],
        };

        
        if(!this.owndata.programas.some(p => p.clave == select.clave)){
          this.owndata.programas.push(select);
          this.selectprograma = '';
        }
      },
      save(){
        this.showedit = false;
        this.loading = true;
        this.editProgramasInformaticos(this.owndata).then(r => {
          if(r){
            this.loading = false;
            this.showedit = false;
          }
        })
      },
      erasePrograma(id){
        this.owndata.programas = this.owndata.programas.filter(el => id != el);
      },
      setData(){
        if(!!this.cvdata){
          this.owndata = this.cvdata; 
          if(!!!this.owndata.programas){
            this.owndata.programas = new Array();
          }
        }
      }
    },
    watch : {
      'cvdata'(){
        this.setData();
      }
    }
  }
</script>

<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/view-parts/espacio-personal/programas-informaticos.vue